import { Card } from '@theneatcompany/nui'

export default Card
